<template>
  <v-list
    pt-0
    dense
  >
    <authenticated-user />
    <!-- end authenticated-user -->

    <v-divider />
    <!-- end divider -->

    <template
      v-for="(link, linkIndex) in links"
    >
      <v-list-tile
        v-if="link.to"
        :key="linkIndex"
        :to="link.to"
      >
        <v-list-tile-action>
          <v-icon v-text="link.icon" />
        </v-list-tile-action>
        <v-list-tile-title v-text="link.text" />
      </v-list-tile>
      <!-- end of link -->

      <v-list-group
        v-else
        :key="linkIndex"
        :prepend-icon="link.icon"
        :value="false"
        no-action
      >
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title v-text="link.text" />
          </v-list-tile>
        </template>
        <!-- end child link handler -->

        <template
          v-for="(child, childIndex) in link.children"
        >
          <v-list-tile
            v-if="child.to"
            :key="childIndex"
            :to="child.to"
          >
            <v-list-tile-action>
              <v-list-tile-title v-text="child.text" />
            </v-list-tile-action>
          </v-list-tile>
        </template>
        <!-- end children links -->
      </v-list-group>
      <!-- end group links -->
    </template>
  </v-list>
</template>

<script>
import AuthenticatedUser from './AuthenticatedUser/AuthenticatedUser'
export default {
  components: {
    AuthenticatedUser
  },
  data: () => ({
    links: [
      {
        text: 'Dashboard',
        icon: 'dashboard',
        to: '/'
      },
      {
        text: 'Blog',
        icon: 'announcement',
        children: [
          {
            text: 'Categories',
            to: '/blog/categories'
          },
          {
            text: 'Posts',
            to: '/blog/posts'
          },
          {
            text: 'Tags',
            to: '/blog/tags'
          },
          {
            text: 'Gallery',
            to: '/blog/gallery'
          }
        ]
      },
      {
        text: 'Application',
        icon: 'apps',
        children: [
          {
            text: 'Users',
            to: '/app/users'
          }
        ]
      }
    ]
  })
}
</script>
